import { Controller } from "@hotwired/stimulus"

const URL_KEYS = ["portfolio_id", "program_id", "phase", "status", "pm_id", "search", "sort_by", "sort_dir", "cols", "col_order"]

export default class extends Controller {
  openSaveModal() {
    const params = new URLSearchParams(window.location.search)
    const state = {}
    URL_KEYS.forEach(k => {
      const v = params.get(k)
      if (v) state[k] = v
    })
    document.dispatchEvent(new CustomEvent("portfolio-preset:open-save", { detail: state }))
    document.dispatchEvent(new CustomEvent("modal:open-by-id", { detail: { id: "portfolio-preset-save" } }))
  }
}
